export enum UserCompany {
  MINISTRY = 'MINISTRY',
  FDJ = 'FDJ',
  PMU = 'PMU',
  LE_TROT = 'LE_TROT',
  FRANCE_GALOP = 'FRANCE_GALOP',
}
